export const PATIENT_AUTH_ENTRY_PATH = '/auth/login';
